export type Theme = 'light' | 'dark' | 'oled'

const STORAGE_KEY = 'stage-theme'

export function getStoredTheme(): Theme | null {
  if (typeof window === 'undefined') return null
  const stored = window.localStorage.getItem(STORAGE_KEY)
  if (stored === 'light' || stored === 'dark' || stored === 'oled') return stored
  return null
}

export function getInitialTheme(): Theme {
  const stored = getStoredTheme()
  if (stored) return stored
  if (typeof window !== 'undefined' && window.matchMedia('(prefers-color-scheme: dark)').matches) {
    return 'dark'
  }
  return 'light'
}

export function applyTheme(theme: Theme) {
  if (typeof document === 'undefined') return
  const html = document.documentElement
  html.classList.remove('light', 'dark', 'oled')
  html.classList.add(theme)
  window.localStorage.setItem(STORAGE_KEY, theme)
}
